export default {
  'input, textarea, select, fieldset': {
    marginBottom: '0rem'
  },
  'pre, blockquote, dl, figure, table, p, ul, ol, form': {
    marginBottom: '2.5rem'
  }
}



// WEBPACK FOOTER //
// ./src/assets/globalStyles/spacing.js